export const CURRENT_ADMIN_TAB= 'CURRENT_ADMIN_TAB'
export const CURRENT_ADMIN_SUB_TAB= 'CURRENT_ADMIN_SUB_TAB'
export const CURRENT_ADMIN_SUB_TAB_CONTAINER= 'CURRENT_ADMIN_SUB_TAB_CONTAINER'